import { useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";

import { Button } from "@components";
import { Input } from "@components/Input";

export const SpecifidDay = ({ data, onApply }) => {
  const [date, setDate] = useState(
    data.type == "SPECIFIC_DAY" ? data.value || "" : ""
  );

  return (
    <div className={styles.specificDays}>
      <div className={styles.hairline} />

      <p className={styles.label}>Defina o dia específico</p>

      <Input
        placeholder="dd/mm/aaaa"
        mask="99/99/9999"
        type="tel"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        autoFocus
      />

      <div className={styles.footer}>
        <Button
          design="simple"
          onClick={() => onApply({ date })}
          className="w-100"
          disabled={date.length !== 10}
        >
          Aplicar
        </Button>
      </div>
    </div>
  );
};
